import utils from "../common/util";

const cmpAppLogo = {
	component: null,

	init: function (element)
	{
		utils.log('cmpAppLogo initiated : #' + element.id, 'info');

		const _ = utils.setEnvironment(this);
		_.component = element;
		_.truth = document.getElementsByClassName('app-logo__truth');
		_.or = document.getElementsByClassName('app-logo__or');
		_.dare = document.getElementsByClassName('app-logo__dare');

		_.animateLogo(_.component);
	},

	animateLogo: function (element)
	{
		const _ = this;

		if (element.classList.contains('animation-setup')) {

			utils.sleep(1000).then(() =>
			{
				element.classList.remove('animation-setup');

				utils.sleep(3000).then(() => {
					element.classList.add('opacity-0');

					utils.sleep(1000).then(() => {
						element.closest('.page-content').classList.remove('v-center');
						utils.showHideElement(element, 'hide');

						utils.animateAndShow(element.nextElementSibling, 'opacity-0');
					});
				});
			});
		}
	}
}

export default cmpAppLogo;
